import { render, staticRenderFns } from "./PermissionViewPermissionInfoCard.vue?vue&type=template&id=7050d8ca&"
import script from "./PermissionViewPermissionInfoCard.vue?vue&type=script&lang=js&"
export * from "./PermissionViewPermissionInfoCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports